export default {
      id: "download-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.svg#download",
      toString: function () {
        return this.url;
      }
    }